import { render, staticRenderFns } from "./CartProduct.vue?vue&type=template&id=606c0f2f&scoped=true&"
import script from "./CartProduct.vue?vue&type=script&lang=js&"
export * from "./CartProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c0f2f",
  null
  
)

export default component.exports